import { render, staticRenderFns } from "./callbackList.vue?vue&type=template&id=5d99f6d7&scoped=true"
import script from "./callbackList.vue?vue&type=script&lang=js"
export * from "./callbackList.vue?vue&type=script&lang=js"
import style0 from "./callbackList.vue?vue&type=style&index=0&id=5d99f6d7&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d99f6d7",
  null
  
)

export default component.exports